import React from 'react';
import './DocumentFilters.css';

interface DocumentFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  typeFilter: string;
  onTypeFilterChange: (type: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
}

const DocumentFilters: React.FC<DocumentFiltersProps> = ({
  searchQuery,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  const handleClearAll = () => {
    onSearchChange('');
    onTypeFilterChange('All Types');
    onStatusFilterChange('All Status');
  };

  const handleSaveView = () => {
    console.log('Save view');
    // TODO: Implement save view functionality
  };

  const handleReset = () => {
    handleClearAll();
    // TODO: Reset to default view
  };

  return (
    <div className="document-filters">
      <div className="document-filter-row">
        <div className="document-search">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search documents..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="document-search-input"
          />
        </div>
        <div className="document-filter-controls">
          <select
            value={typeFilter}
            onChange={(e) => onTypeFilterChange(e.target.value)}
            className="document-filter-select"
          >
            <option>All Types</option>
            <option>Health Permit</option>
            <option>Business License</option>
            <option>Insurance Certificate</option>
            <option>Food Safety Certificate</option>
          </select>
          <select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            className="document-filter-select"
          >
            <option>All Status</option>
            <option>Pending</option>
            <option>Approved</option>
            <option>Rejected</option>
            <option>Needs Info</option>
          </select>
        </div>
      </div>
      <div className="document-filter-actions">
        <button className="document-filter-action-btn" onClick={handleClearAll}>
          <span>🔽</span> Clear All
        </button>
        <button className="document-filter-action-btn" onClick={handleSaveView}>
          Save View
        </button>
        <button className="document-filter-action-btn" onClick={handleReset}>
          Reset
        </button>
      </div>
    </div>
  );
};

export default DocumentFilters;

